import React, { forwardRef } from 'react';

const Input = forwardRef(({ 
  type = 'text',
  placeholder = '',
  className = '',
  error = false,
  disabled = false,
  label,
  helperText,
  required = false,
  ...props 
}, ref) => {
  const baseClasses = 'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50';
  
  const errorClasses = error ? 'border-destructive focus:ring-destructive' : '';
  
  const inputClasses = `${baseClasses} ${errorClasses} ${className}`?.trim()?.replace(/\s+/g, ' ');

  const inputElement = (
    <input
      ref={ref}
      type={type}
      placeholder={placeholder}
      className={inputClasses}
      disabled={disabled}
      required={required}
      {...props}
    />
  );

  if (label || helperText) {
    return (
      <div className="space-y-2">
        {label && (
          <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
            {label}
            {required && <span className="text-destructive ml-1">*</span>}
          </label>
        )}
        {inputElement}
        {helperText && (
          <p className={`text-sm ${error ? 'text-destructive' : 'text-muted-foreground'}`}>
            {helperText}
          </p>
        )}
      </div>
    );
  }

  return inputElement;
});

Input.displayName = 'Input';

export default Input;